export default "__VITE_ASSET__DMVw9DVA__"